import { ReactElement, ReactNode, useState } from "react"

import CreateDeviceProvider from "./baseProviders/createDeviceProvider"
import { useGetUserData } from "../../../../hooks/useGetUserData"
import useDeviceReference from "../../../../services/middleware/hooks/devices/ttr/useDeviceReference"
import { getEmptyTTRDeviceFormData } from "../../../../utils/registerDevice/registerDeviceUtils"
import { TTRDeviceFormData } from "../types/providerTypes"

interface IPublishDeviceProviderProps {
    children: ReactNode
}

/** Context provider for the device publish form, all data relevant to the form should be stored here */
const PublishDeviceProvider = ({
    children,
}: IPublishDeviceProviderProps): ReactElement => {
    const [formData, setFormData] = useState<TTRDeviceFormData>(
        getEmptyTTRDeviceFormData()
    )

    const { isEnaSysAdmin, isManuApproved } = useGetUserData()

    const doesNotNeedManufacturerId = !isEnaSysAdmin && isManuApproved

    const manufacturerId = doesNotNeedManufacturerId
        ? undefined
        : formData.coreDetails.manufacturer

    const {
        isValidating,
        isLoading,
        error: deviceRefError,
        deviceId,
        deviceRef,
    } = useDeviceReference(manufacturerId)

    const deviceRefIsLoaded = !isValidating && !isLoading && !deviceRefError

    const loadedDeviceId = deviceRefIsLoaded ? deviceId : undefined
    const loadedDeviceRef = deviceRefIsLoaded ? deviceRef : undefined

    return (
        <CreateDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={deviceRefError}
            deviceId={loadedDeviceId}
            deviceRef={loadedDeviceRef}
            canEditManufacturer={isEnaSysAdmin}
        >
            {children}
        </CreateDeviceProvider>
    )
}

export default PublishDeviceProvider
